import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { Webform } from '@uncinc/react-drupal-core';
import React from 'react';
import { BlockContactForm as BlockContactFormProps } from '../../../types/uncinc_profile/blocks';
import { DynamicMediaItem, BlockContactForm } from '../../../components';

export interface ContactFormBlockProps {
  entity: ImmutableEntity<BlockContactFormProps>;
}

const ContactFormBlock: React.FC<ContactFormBlockProps> = ({
  entity,
}) => {
  const contactFormBlockEntity = entity.toJS();

  const title = contactFormBlockEntity.info[0].value;

  const body = contactFormBlockEntity.body[0].value;

  const webformId = contactFormBlockEntity.field_webform[0]?.target_id;

  const media = contactFormBlockEntity.field_media[0];

  return (
    <BlockContactForm
      title={title}
      body={body}
      webform={webformId && <Webform id={webformId} />}
      image={media && <DynamicMediaItem media={media} imageAspectRatio="1_1" />}
    />
  );
};

export default ContactFormBlock;
